module.exports = require("./mua.d.ts");